import React, { FC, useEffect, useState } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { Box } from '@mui/material'
import { app } from 'config'
import { storage } from 'utils'
import { BlankLayout, ErrorBoundary, Loader } from '../../'
import { BaseLayoutHeader } from './components'
import useStyle from './base-layout-style'

interface IProps {
  maxWidth?: string
  children?: JSX.Element | JSX.Element[]
  boxLayoutClassName?: string
}

const BaseLayout: FC<IProps> = ({ maxWidth, children, boxLayoutClassName }) => {
  const authData = useOktaAuth()
  const { classes } = useStyle()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    storage.setUser()
    if (authData && authData.authState) {
      setIsLoading(false)
    }
  }, [authData])

  if (isLoading) {
    return (
      <BlankLayout data-testid="blank-layout">
        <Loader />
      </BlankLayout>
    )
  }

  if (!authData || !authData.authState || authData.authState.isPending) {
    return (
      <BlankLayout data-testid="blank-layout">
        <Loader />
      </BlankLayout>
    )
  }

  return (
    <ErrorBoundary>
      <Box marginX={[1, 2, 3]} marginY={[3, 3, 4]} className={classes.root}>
        <BaseLayoutHeader />
        {/* Module Container: Start */}
        <Box
          maxWidth={maxWidth || app.layoutAndModuleWidth}
          marginX="auto"
          marginY="5em"
          paddingX={[2, 0, 0]}
          className={boxLayoutClassName}
        >
          {children}
        </Box>
        {/* Module Container: End */}
      </Box>
    </ErrorBoundary>
  )
}

export default BaseLayout
